// extracted by mini-css-extract-plugin
module.exports = {"root":"UiPreloader_root_1VM4Z","isFullscreen":"UiPreloader_isFullscreen_1foev"};